import * as React from 'react';
export const hyponoeSvg = React.forwardRef(function hyponoeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FDD205',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#13356D',
          d: 'M29.2 11.64c-3.13 0-8.08.8-12.65 5.06-4.91 4.6-9.89 5.6-13.16 5.6h-.03c-1.54 0-2.72-.22-3.35-.37V32h32V11.87l-.49-.07c-.54-.1-1.34-.16-2.31-.16',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#1378C7',
          d: 'M.83 20.15c.83.14 1.67.22 2.52.21 3 0 7.54-.84 12.2-5.06A20.09 20.09 0 0 1 32 10.21V0H0v19.96l.15.04.68.15',
        }),
      ),
    ),
  );
});
hyponoeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var hyponoe = {
  category: 'brand',
  colorable: false,
  name: 'hyponoe',
  svg: hyponoeSvg,
};
